
const pageStatus = {
  player: 0,
  songList: 1,
  bgList: 2,
};

export default pageStatus;




// WEBPACK FOOTER //
// ./src/common/constants.js